export default {
    curPanel : -1,
    panels : [
                'Intro',
                'Challenges',
                'Body',
                'Magic',
                'Color',
                'Social',
                'Importance',
                'Changes',
                'Conclusion'
            ]
}